import { render } from "./RootSidebar.vue?vue&type=template&id=e01b3ae4&scoped=true"
import script from "./RootSidebar.vue?vue&type=script&lang=js"
export * from "./RootSidebar.vue?vue&type=script&lang=js"

import "./RootSidebar.vue?vue&type=style&index=0&id=e01b3ae4&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e01b3ae4"]])

export default __exports__